import {
  globalSearchParamsSchema,
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_VALUE_STORY_ID = 'valueStoryId'

export const valueStoriesSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_SITE_ID]: z.string(),
})

export const valueStorySearchParams = valueStoriesSearchParams.extend({
  [SEARCH_PARAM_VALUE_STORY_ID]: z.string(),
})

export const valueStoryDetailsSearchParams = valueStorySearchParams.extend({
  view: z.string().optional(),
  _refresh: z.number().optional(),
})

type ValueStoriesSearchInput = {
  orgId: string | undefined
  siteId: string
}

export const makeValueStoriesRouteSearch = ({
  orgId,
  siteId,
}: ValueStoriesSearchInput) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const createValueStorySearch = ({
  orgId,
  siteId,
  valueStoryId,
}: ValueStoriesSearchInput & {
  valueStoryId: string
}) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
  [SEARCH_PARAM_VALUE_STORY_ID]: valueStoryId,
})
